// index.js

import React from 'react';
import ReactDOM from 'react-dom';
import './global.css';
import Root from './Root';
// import './theme.css';  // 玻璃拟态主题（已停用，备份在 theme.glass.css.bak）

import reportWebVitals from './reportWebVitals';

// 错误边界：把渲染错误显示在页面上，方便在内嵌浏览器里排查
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { err: null, info: null };
    }
    static getDerivedStateFromError(err) {
        return { err };
    }
    componentDidCatch(err, info) {
        this.setState({ info });
        if (window.__errH) {
            window.__errH('REACT: ' + (err && (err.stack || err.message) || err));
        }
    }
    render() {
        if (this.state.err) {
            const comp = ((this.state.info && this.state.info.componentStack) || '(none)');
            const msg = 'REACT ERROR: ' + String((this.state.err && this.state.err.message) || this.state.err)
                + '\n\nCOMPONENT STACK:' + comp;
            return React.createElement('div', {
                style: {
                    color: '#fff', background: '#b00020', font: '10px/1.4 monospace',
                    padding: '6px', whiteSpace: 'pre-wrap', wordBreak: 'break-all', height: '100%', overflow: 'auto'
                }
            }, msg);
        }
        return this.props.children;
    }
}

try {
    ReactDOM.render(
        <ErrorBoundary>
            <Root />
        </ErrorBoundary>,
        document.getElementById('root')
    );
} catch (e) {
    if (window.__errH) window.__errH('RENDER THROW: ' + (e && (e.stack || e.message) || e));
}

reportWebVitals();
